import {DefaultPortModel, DefaultPortModelOptions, PortModel} from "@projectstorm/react-diagrams";
import {NodeLinkModel} from "../links/NodeLinkModel";
import {PortModelAlignment} from "@projectstorm/react-diagrams-core";
import {Action, SideOutPortDefinition} from "../../editorSlice";
import {DataNodeModel} from "../nodes/DataNodeModel";
import {
    DeserializeEvent,
  } from "@projectstorm/react-canvas-core";

export class DataSidePortModel extends DefaultPortModel {

    actions!:Action[]
    dynamicSideout!:boolean

    constructor(options: DefaultPortModelOptions | boolean, name?: string, id?: string, actions?:Action[],dynamicSideout?:boolean) {
        if (!!name) {
            options = {
                in: false,
                name: name,
                id: id,
            };
        }
        options = options as DefaultPortModelOptions;
        super({
            label: options.label || options.name,
            alignment: PortModelAlignment.RIGHT,
            type: "sideout",
            
            ...options
        });
        if(actions) {
            this.actions = actions
        }
        if(dynamicSideout) {
            this.dynamicSideout = dynamicSideout
        }
    }

    // @ts-ignore
    createLinkModel(): NodeLinkModel | null {
        return new NodeLinkModel();
    }


    getNode(): DataNodeModel {
        return super.getNode() as DataNodeModel;
    }

    getDefinition(): SideOutPortDefinition | undefined {
        const sc = this.getNode().schema
        if(sc){
            if(sc.sideout){
                let def = sc.sideout.find(p => p.name === this.getName())
                if (def !== undefined){
                    return def
                }
            }
        }

        // if(this.getNode().dynamicSideOut){
        //     let def = this.getNode().dynamicSideOut.find(p => p.name === this.getName())
        //     if(def){
        //         return def
        //     }
        // }
        return undefined
    }

    getOutId():string{
        return this.options.id || ''
    }

    canLinkToPort(port: PortModel): boolean {
        // if(Object.keys(this.getLinks()).length > 1){
        //     console.warn('to many link for this port')
        //     return false
        // }

        if (port instanceof DefaultPortModel) {
            return this.options.in !== port.getOptions().in;
        }
        return true;
    }

    remove() {
        Object.keys(this.getLinks()).forEach(link => {
            this.getLinks()[link].remove()
        })

        super.remove();
    }

    serialize() {
        return {
          ...super.serialize(),
          actions: this.actions,
          dynamicSideout: this.dynamicSideout
        };
      }
    
      deserialize(event: DeserializeEvent<this>): void {
        super.deserialize(event);
        this.actions = event.data.actions     
        this.dynamicSideout = event.data.dynamicSideout     
     }
}
